import React from 'react';
import ReactDOM from 'react-dom';

import './styles/index.scss';

import App from './App';
import "./i18n";
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js